import Vue from 'vue'

import {mapGetters} from 'vuex'

import template from './digital_support_movement.pug'

import Mixin from '../municipality-data/balance/account/_transactions_mixin'

const QR_MEDIA_TYPE = 2
const TNE_MEDIA_TYPE = 4

const TYPE_CHARGE = 5
const TYPE_VALIDATION = 8
const TYPE_RECHARGE = 4



const VALIDATION_TYPE_VALIDATION = 1
const VALIDATION_TYPE_HOP_ON_HOP_OFF = 2
const VALIDATION_TYPE_PENALIZATION = 3

export default Vue.extend({
  name: 'movements-history-digital-support',
  template: template(),
  mixins: [Mixin],
  props: {
    movimiento: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      QR_MEDIA_TYPE,
      TNE_MEDIA_TYPE,
      TYPE_CHARGE,
      TYPE_VALIDATION,
      VALIDATION_TYPE_VALIDATION,
      VALIDATION_TYPE_HOP_ON_HOP_OFF,
      VALIDATION_TYPE_PENALIZATION
    }
  },

  computed: {
    // Formateo de fecha
    formattedDate() {
      const date = new Date(this.movimiento.created_at)
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      const month = months[date.getMonth()]
      const day = date.getDate()
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      return `${month} ${day} ${hours}:${minutes}`
    },

    // Determina el tipo de movimiento
    isCharge() {
      return this.movimiento.type === TYPE_CHARGE
    },

    isValidation() {
      return this.movimiento.type === TYPE_VALIDATION
    },

    isRecharge() {
      return this.movimiento.type === TYPE_RECHARGE
    },



    // Validaciones específicas
    isValidationSimple() {
      return this.isValidation && this.movimiento.validation_type === VALIDATION_TYPE_VALIDATION
    },

    isVoidedValidation() {
      return this.isValidation && this.movimiento.voided_validation
    },

    hasDestination() {
      return this.movimiento.has_destination
    },

    // Texto del tipo de movimiento
    operationTypeText() {
      if (this.isValidation) return this.$t('balance.transaction.type.validation')
      if (this.isCharge) return this.movimiento.description
      if (this.isRecharge) return this.$t('movementsHistory.pendingRecharge') //Si viene un type 4 quiere decir que es una recarga pendiente de aplicación
      // if (this.isCharge) return this.$t('balance.transaction.type.recharge') // TODO: Cambiar a this.movimiento.description
      // if (this.isRecharge) return this.$t('movementsHistory.recharge') // TODO: Cambiar a this.movimiento.description
      return ''
    },

    // Color del tipo de movimiento
    operationTypeColor() {
      if (this.isCharge || this.isRecharge) return 'text-primary'
      return 'text-gray2'
    },

    amountColor() {
      return this.isValidation ? 'text-danger' : 'text-primary'
    },

    // Determina si mostrar información extra
    hasExtraInfo() {
      return this.isValidation || this.isCharge || this.isRecharge
    },

    // Obtiene el monto principal a mostrar
    displayAmount() {
      if (this.isCharge || this.isRecharge) {
        return this.movimiento.recharge_amount || 0
      }
      if (this.isValidation) {
        return this.movimiento.amount || 0
      }
      return 0
    },

    // Texto para la sección de información extra
    extraInfoText() {
      if (this.isValidation) return this.$t('balance.transaction.validationAmount')
      if (this.isCharge) return this.$t('balance.products.balance')
      if (this.isRecharge) return this.$t('balance.products.balance')
      return ''
    },

    // Ruta y paradas
    route() {
      return this.movimiento.route || {}
    },

    stop() {
      return this.movimiento.stop || {}
    },

    // Color de la ruta
    routeColor() {
      const color = this.route.color || this.route.colour
      return color ? `background-color: ${color}` : ''
    },

    // Nombre del tipo de medio
    mediaTypeName() {
      if (!this.movimiento.media_type) { return '' }
      return this.$t(`balance.transaction.mediaTypes.${this.movimiento.media_type}`)
    },

    // Icono del tipo de medio
    mediaTypeIcon() {
      const icons = {}
      icons[QR_MEDIA_TYPE] = 'ns-icon-qr'
      icons[TNE_MEDIA_TYPE] = 'ns-icon-tne'
      return icons[this.movimiento.media_type]
    },

    // Icono del tipo de validación
    validationTypeIcon() {
      return 'ns-icon-bus'
    },

    // Nombre del tipo de transacción
    typeName() {
      if (this.movimiento.type === TYPE_CHARGE) { return this.$t('balance.transaction.type.recharge') }
      if (this.movimiento.type === TYPE_VALIDATION) { return this.validationTypeName }
      if (this.movimiento.type === TYPE_RECHARGE) { return this.$t('movementsHistory.recharge') }
      return ''
    },

    validationTypeName() {
      const names = {}
      names[VALIDATION_TYPE_VALIDATION] = this.$t('balance.transaction.type.validation')
      names[VALIDATION_TYPE_HOP_ON_HOP_OFF] = this.$t('balance.transaction.type.hopOnHopOff')
      names[VALIDATION_TYPE_PENALIZATION] = this.$t('balance.transaction.type.penalization')

      return names[this.movimiento.validation_type]
    },

    // Icono del tipo de la transacción
    typeIcon() {
      if (this.movimiento.type === TYPE_CHARGE) { return 'ns-icon-coins text-primary' }
      if (this.movimiento.type === TYPE_VALIDATION) { return this.validationTypeIcon }
      if (this.movimiento.type === TYPE_RECHARGE) { return 'ns-icon-coins text-primary' }
      return ''
    },

    // Color del tipo de la transacción
    typeColor() {
      if (this.movimiento.type === TYPE_CHARGE) { return 'text-primary' }
      if (this.movimiento.type === TYPE_RECHARGE) { return 'text-primary' }
      return 'text-gray2'
    },

    formattedAmount() {
      return this.$options.filters.moverickCurrency(this.displayAmount)
    },
    formattedBalanceBefore() {
      const balanceBefore = this.movimiento.balance_before || null
      return balanceBefore ? this.$options.filters.moverickCurrency(balanceBefore) : null
    },
    formattedFinalBalance() {
      const finalBalance = this.movimiento.final_balance || this.movimiento.calculated_balance || this.movimiento.balance_after || null
      return finalBalance ? this.$options.filters.moverickCurrency(finalBalance) : null
    },

    operatorName() {
      return this.movimiento.operator_name || ''
    },

    tripWord() {
      return this.displayAmount > 1 ? 
        this.$t('balance.transaction.travels') : 
        this.$t('balance.transaction.travel')
    },

    showRouteInfo() {
      return this.isValidation && this.movimiento.route
    }
  },

  watch: {
  },

  created() {
  },

  methods: {
  }
})

